import { Component, OnInit, Input } from '@angular/core';
import { SetService, HttpService } from 'ngx-block-core';
import { FormControlService } from "ngx-block-core";
import { iconTheme2 } from "../../../data/data";

@Component({
    selector: 'app-sucu06-element0020001',
    templateUrl: './sucu06-element0020001.component.html',
})
export class Sucu06Element0020001Component implements OnInit {

    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() nzFormGroupData;
    @Input() nzLayout = 'horizontal'

    value
    @Input() sets = {
        blockCode:"sucublock34",
        blockId: "",
        layoutId: "",
        blockType: 'element',
        blockChildType: '',
        versionCode: 1,
        styles: {
            nzIconSize: "24",
            nzIconType: "home",
            nzIconTheme: "outline",
            nzIconColor: "",
            nzIconSpin: false

        },
        datas: {
            nzDynamicValue: {
                nzUsed: false,
                nzDynamicSql: ""

            }

        }
    };

    setData = []

    constructor(
        public setService: SetService,
        private formControlService: FormControlService,
        private http: HttpService,
        
    ) { }
    ngOnInit() {

        this.baseInit();

        this.autoUpdate();
    }

    autoUpdate() {

        //v3,升级自定义表单参数
        if (this.sets.versionCode < 2) {
    
            this.sets.blockCode = "sucublock34";
    
            this.sets.versionCode = 2;
        }
    
    }
    setDataInit() {
        this.setData = [

            {
                tabName: '样式',
                datas: [

                    {
                        type: 'styles',
                        data: [

                            {
                                name: 'number',
                                inputs: { nzText: "图标尺寸:", nzKeys: ['styles', 'nzIconSize'], nzFormat: ' px' }
                            },
                            {
                                name: 'select',
                                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIconTheme'], nzData: iconTheme2 },
                                outputs: {
                                    ngModelChange: (event) => {

                                        
                                        if (event == 'twotone') {

                                            this.setService.setDatas[this.blockid][0]['datas'][0]['data'][3]['show'] = true;

                                        } else {
                                            this.setService.setDatas[this.blockid][0]['datas'][0]['data'][3]['show'] = false;

                                        }

                                        this.setService.onReLoadbBlock(this.layoutid);

                                    }
                                }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "图标类型:", nzKeys: ['styles', 'nzIconType'] },
                                outputs: { ngModelChange: () => { if (this.sets.styles.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                            },
                            {
                                name: 'color',
                                show: this.sets.styles.nzIconType == 'twotone',
                                inputs: { nzText: "图标颜色:", nzKeys: ['styles', 'nzIconColor'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "动画:", nzKeys: ['styles', 'nzIconSpin'], nzPopContent: ['图标动画'] }
                            },

                        ]
                    },

                ]
            },

        ]
    }
    baseInit() {

        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                console.log("sets", this.sets, this.blockid)

                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;


                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }
               

            }
            else {//静态
                if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
            }
        }
    }



}
